import { SearchParams, YadoHotel } from "../types";
import HotelItem from "./HotelItem";

type HotelListProps = {
  hotels: YadoHotel[];
  query: SearchParams;
  fetchedQuery: SearchParams;
  sortBy: string;
  onClickArea: (e: React.MouseEvent<HTMLDivElement>, areaCode: string) => void;
}

const HotelList: React.FC<HotelListProps> = ({ hotels, query, fetchedQuery, sortBy, onClickArea }) => {
  return (
    <>
      {hotels.map((hotel) => {
        return (
          <div key={`hotel-item-${hotel.id}`}>
            <HotelItem hotel={hotel} query={query} fetchedQuery={fetchedQuery} sortBy={sortBy} onClickArea={onClickArea} />
          </div>
        )
      })}
    </>
  );
};

export default HotelList;
